import { SplitOrderConfirmation } from "./SplitOrderConfirmation";
export default SplitOrderConfirmation;